import { render, staticRenderFns } from "./cover-upload.vue?vue&type=template&id=e540929e&scoped=true&"
import script from "./cover-upload.vue?vue&type=script&lang=js&"
export * from "./cover-upload.vue?vue&type=script&lang=js&"
import style0 from "./cover-upload.vue?vue&type=style&index=0&id=e540929e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e540929e",
  null
  
)

export default component.exports